module.exports = __webpack_public_path__ + "static/media/schedule_old.19391f1d.svg";